export default __webpack_public_path__ + "static/media/paintball.fab35265.png";